// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container general */
.ShoppingCart_container__73onL {
  max-width: 1140px;
  width: 100%;
  margin: 0 auto; /* Adaugă margin pentru a centra containerul */
  padding: 10px 0;
  flex: 1 1;
}

.ShoppingCart_content__a5I56 {
  margin-top: 10px;
}

/* Responsive */
@media (max-width: 768px) {
  .ShoppingCart_container__73onL {
    padding-top: 60px;
  }

  .ShoppingCart_content__a5I56 {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/ShoppingCart.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc,EAAE,8CAA8C;EAC9D,eAAe;EACf,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,sBAAsB;EACxB;AACF","sourcesContent":["/* Container general */\n.container {\n  max-width: 1140px;\n  width: 100%;\n  margin: 0 auto; /* Adaugă margin pentru a centra containerul */\n  padding: 10px 0;\n  flex: 1;\n}\n\n.content {\n  margin-top: 10px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .container {\n    padding-top: 60px;\n  }\n\n  .content {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShoppingCart_container__73onL`,
	"content": `ShoppingCart_content__a5I56`
};
export default ___CSS_LOADER_EXPORT___;
